import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { SharedService } from '../back-office/modules/shared-service.service';

@Component({
  selector: 'app-enovsky',
  templateUrl: './enovsky.component.html',
  styleUrls: ['./enovsky.component.scss',
              '../../public/module/style.css',
              '../../public/module/bootstrap.css',
               '../../public/module/theme.css',
              '../../public/module/animate.css'
  ]
})
export class EnovskyComponent {
  constructor(
    private elRef: ElementRef,
    private sharedService: SharedService,
  ) {}
  @ViewChild('sidenav') sidenav!: MatSidenav;
  scrollY = 0;
  distance = 50;
  speed = 24;
  currentRoute = '';
  activePage = 'dashboard-student';
  ngAfterViewInit() {
    this.sharedService.data.subscribe(data => {
      if(data['close_side_nav']){
        this.sidenav.close();
      };
    });
  }
  shareUserData(){

  }
  showHidePage(pageId:string){
    //this.activePage = pageId;
    this.sharedService.sendData({side_enovsky_banner_page_id: pageId, close_side_nav: true});
  }
}
